/** "$1.5M", "$250K", "$4,200": the compact dollar figure lists use. */
export const money = (n: number): string =>
  n >= 1e6 ? `$${(n / 1e6).toFixed(n >= 1e7 ? 0 : 1)}M` : n >= 1e3 ? `$${Math.round(n / 1e3)}K` : `$${Math.round(n).toLocaleString()}`;

/** What a stored prior-award value is based on (awardHistory.estimateValue, plus an Award Notice's own amount). */
export const BASIS_LABEL: Record<string, string> = {
  award: 'Award amount on this notice',
  same_office_active: 'Current award from this office',
  same_office_recent: 'Last award from this office',
  agency_state_active: 'Current award, this agency in state',
  agency_state_recent: 'Recent award, this agency in state',
};
